import type {FileAsset} from '@/types'

export function resolveFileUrl(url?: string | null) {
  return url || undefined
}

export function getFileAssetUrl(file?: FileAsset | null) {
  return resolveFileUrl(file?.url)
}
